module.exports = __webpack_public_path__ + "static/media/ev-catalog-screenshot.8cf32d27.png";